import React from 'react';
import PropTypes from 'prop-types';

const Message = ({ getTotalTasks, getCompletedTasks }) => {
  if (getCompletedTasks === 5) {
    return <p>You Won The Day!</p>;
  }
  if (getTotalTasks === 5) {
    return <p>A total of 5 tasks are allowed.</p>;
  }
  return <p>Nothing to return</p>;
};

Message.propTypes = {
  getTotalTasks: PropTypes.number.isRequired,
  getCompletedTasks: PropTypes.number.isRequired
};

export default Message;
